export interface contactHistory {
  id: number;
  time: string;
  customer: string;
  status: string;
  skill: string;
  disposition: string;
  notes?: string;
  tags?: Array<string>;
  channel: string;
}

export const contactHistoryListData: contactHistory[] = [
  {
    id: 40001,
    time: new Date(new Date(Date.now() - 86400000).setHours(14, 10, 0, 0)).toISOString(),
    customer: 'Sarah Johnson',
    status: 'Closed',
    skill: 'Inbound Voice',
    disposition: 'Closed',
    notes:
      'Sarah called in to check up on the status of her order. We were able to resolve her issue',
    tags: ['Complaint', 'Tech Support'],
    channel: 'Usha-Routing-Queue',
  },
  {
    id: 40002,
    time: new Date(new Date(Date.now() - 86400000).setHours(8, 1, 0, 0)).toISOString(),
    customer: 'James Rodriguez',
    status: 'Closed',
    skill: 'Chat',
    disposition: 'Closed',
    notes:
      'James called in to check up on the status of his order. We were able to resolve his issue',
    tags: ['Complaint', 'Tech Support'],
    channel: 'KK-Chat-Queue',
  },
  {
    id: 40003,
    time: new Date(new Date(Date.now() - 86400000).setHours(8, 30, 0, 0)).toISOString(),
    customer: 'Emily Chen',
    status: 'Closed',
    skill: 'Outbound Voice',
    disposition: 'Closed',
    notes:
      'Emily called in to check up on the status of her order. We were able to resolve her issue',
    tags: ['Complaint', 'Tech Support'],
    channel: 'Usha-Routing-Queue',
  },
  {
    id: 40004,
    time: new Date(new Date(Date.now() - 86400000).setHours(12, 10, 0, 0)).toISOString(),
    customer: 'Liam Mitchell',
    status: 'Open',
    skill: 'Email',
    disposition: 'Open',
    notes:
      'Liam called in to check up on the status of his order. We are looking into his issue',
    tags: ['Complaint', 'Tech Support'],
    channel: 'KP-Email-Queue',
  },
  {
    id: 40005,
    time: new Date(new Date(Date.now() - 86400000).setHours(17, 15, 0, 0)).toISOString(),
    customer: 'Olivia Walker',
    status: 'Open',
    skill: 'Instagram',
    disposition: 'Open',
    notes:
      'Olivia called in to check up on the status of her order. We are looking into her issue',
    tags: ['Complaint', 'Tech Support'],
    channel: 'KK-Instagram-Queue',
  },
  {
    id: 40006,
    time: new Date(new Date(Date.now() - 86400000).setHours(8, 1, 0, 0)).toISOString(),
    customer: 'Alex Thompson',
    status: 'Closed',
    skill: 'Inbound Voice',
    disposition: 'Closed',
    notes:
      'Alex called in to check up on the status of his order. We were able to resolve his issue',
    tags: ['Complaint', 'Tech Support'],
    channel: 'Usha-Routing-Queue',
  },
  {
    id: 40007,
    time: new Date(new Date(Date.now() - 86400000).setHours(8, 30, 0, 0)).toISOString(),
    customer: 'Daniel Garcia',
    status: 'Open',
    skill: 'Outbound Voice',
    disposition: 'Open',
    notes:
      'Daniel called in to check up on the status of his order. We are looking into his issue',
    tags: ['Complaint', 'Tech Support'],
    channel: 'Usha-Routing-Queue',
  },
  {
    id: 40008,
    time: new Date(new Date(Date.now() - 86400000).setHours(8, 30, 0, 0)).toISOString(),
    customer: 'Grace Cooper',
    status: 'Closed',
    skill: 'Chat',
    disposition: 'Closed',
    notes:
      'Grace called in to check up on the status of her order. We were able to resolve her issue',
    tags: ['Complaint', 'Tech Support'],
    channel: 'KK-Chat-Queue',
  },
  {
    id: 40009,
    time: new Date(new Date(Date.now() - 86400000).setHours(8, 1, 0, 0)).toISOString(),
    customer: 'Mia Taylor',
    status: 'Closed',
    skill: 'Email',
    disposition: 'Closed',
    notes:
      'Mia called in to check up on the status of her order. We were able to resolve her issue',
    tags: ['Complaint', 'Tech Support'],
    channel: 'KP-Email-Queue',
  },
  {
    id: 40010,
    time: new Date(new Date(Date.now() - 86400000).setHours(8, 1, 0, 0)).toISOString(),
    customer: 'Ethan Davis',
    status: 'Open',
    skill: 'Inbound Voice',
    disposition: 'Open',
    notes:
      'Ethan called in to check up on the status of his order. We are looking into his issue',
    tags: ['Complaint', 'Tech Support'],
    channel: 'Usha-Routing-Queue',
  },
];
